import SECTION_TYPES from './types';
import { type ISection, type IVideo } from 'src/models';
import VIDEO_TYPES from '../Videos/types';

export interface State {
	sections: ISection[];
	section: ISection;
	isLoading: boolean;
	isLoadingOne: boolean;
	isUploadingVideo: boolean;
	videoDialogOpen: boolean;
}

const initialState: State = {
	sections: [],
	section: {},
	isLoading: false,
	isLoadingOne: false,
	isUploadingVideo: false,
	videoDialogOpen: false,
};

const reducer = (state: State = initialState, action: any) => {
	const { type, payload } = action;
	switch (type) {
		case SECTION_TYPES.GET_BY_USER:
		case SECTION_TYPES.GET_ALL: {
			return {
				...state,
				isLoading: true,
			};
		}

		case SECTION_TYPES.SET_ALL: {
			return {
				...state,
				isLoading: false,
				sections: payload.sections,
			};
		}

		case SECTION_TYPES.GET_ONE: {
			return {
				...state,
				isLoadingOne: true,
				isUploadingVideo: false,
			};
		}

		case SECTION_TYPES.SET_ONE: {
			return {
				...state,
				isLoadingOne: false,
				section: payload.section,
			};
		}

		case SECTION_TYPES.INITIAL_STATE: {
			return initialState;
		}

		case VIDEO_TYPES.MARK_SEEN: {
			const sections = [...state.sections];
			const sectionIndex = sections.findIndex(
				(section: ISection) => section.id == payload.sectionId,
			);
			const videoIndex = sections[sectionIndex].videos?.findIndex(
				(video: IVideo) => video.id == payload.videoId,
			) ?? -1;

			if (
				sections[sectionIndex] &&
				sections[sectionIndex].videos
			) {
				sections[sectionIndex].videos![videoIndex].seen = true;
			}

			return {
				...state,
				sections,
			};
		}

		case SECTION_TYPES.UPDATE_ORDER: {
			return {
				...state,
				sections: payload.sections,
			};
		}

		case VIDEO_TYPES.UPDATE_ORDER: {
			return {
				...state,
				section: {
					...state.section,
					videos: payload.videos,
				},
			};
		}

		case VIDEO_TYPES.CREATE: {
			return {
				...state,
				isUploadingVideo: true,
			};
		}

		case VIDEO_TYPES.UPDATE: {
			return {
				...state,
				isUploadingVideo: false,
			};
		}

		case SECTION_TYPES.SET: {
			return {
				...state,
				[payload.key]: payload.value,
			};
		}

		default:
			return state;
	}
};

export default reducer;
